import Header from "../../Header";
import {useNavigate, useParams} from "react-router-dom";
import {ChangeEvent, FormEvent, useEffect, useState} from "react";
import {Transaction} from "../../Types/Transaction";
import {getTransaction, putTransactionNote} from "../../API/TransactionManager";
import formStyle from "../../General CSS/Form.module.css";

export default function Note() {
    const { id, categoryUid } = useParams<{ id: string, categoryUid: string }>();
    const navigate = useNavigate();
    const [transaction, setTransaction] = useState<Transaction>();
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [noteData, setNoteData] = useState({ note: "" });

    useEffect(() => {
        if (!id || !categoryUid) {
            navigate("/account/overview");
        }
    }, [id, categoryUid, navigate]);

    useEffect(() => {
        if (!id || !categoryUid) return;
        
        getTransaction(id, categoryUid)
            .then((data: Transaction) => {
                setTransaction(data);
            })
            .catch((err: any) => setError(err.message || "Unknown error"))
            .finally((): void => setLoading(false));
    }, [id, categoryUid]);

    useEffect(() => {
        if (!transaction) return;
        
        if (transaction?.note !== undefined) {
            setNoteData({ note: transaction.note });
        }
    }, [transaction]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault();

        if (noteData.note === undefined) {
            alert("Please enter a note!");
            return;
        }

        try {
            if (id && categoryUid) {
                await putTransactionNote(id, categoryUid, noteData.note);
            }
            navigate("/account/overview");
        } catch (err: any) {
            alert(err.message || "Failed to add note");
        }
    }

    return (
        <>
            <Header page={"Add a Note"} returnLink={"/account/overview"}/>
            <div className={formStyle.wrapper}>
                <form onSubmit={handleSubmit}>
                    <div className={formStyle.dropdown}>
                        <label htmlFor="currentNote" className={formStyle.label}>Note:</label>
                        <input id="currentNote" placeholder="Enter a note" className={formStyle.inputText} defaultValue={noteData.note} onChange={(e: ChangeEvent<HTMLInputElement>): void => setNoteData({ note: e.target.value })} />
                    </div>
                    <div className={formStyle.submit}>
                        <input className={formStyle.submitBtn} type="submit" value="Submit" title="Submit" />
                    </div>
                </form>
            </div>
        </>
    );
}